import React, { useEffect, useState, useRef } from 'react';
import { GetUser, GetScope, useToken22 } from '../features/authentication/hooks/useToken';
import { useTranslation } from 'react-i18next';
import { changeLanguage } from 'i18next';
import { useClientUser } from '../providers/client.provider';
import { Box, Tooltip, useTheme } from '@mui/material';
import { clearCacheItems } from '../util/account';
import Avatar from '../components/avatar';
import '../styles/icon.scss';
import { Link } from 'react-router-dom';
import { AllowByFlag } from '../components/permission';
// import "../icon.scss";

// Account Menu Component
const AccountMenu = () => {
  const [doLogout, setDoLogout] = useState(false);
  const { t, i18n } = useTranslation();
  const { clearToken } = useToken22();
  const { clientUser } = useClientUser();
  var user = GetUser();
  let customerId = GetScope();
  const theme = useTheme();

  const languages = [
    { code: 'en', name: 'English', flag: '/images/us.jpg' },
    { code: 'es', name: 'Español', flag: '/images/spain.jpg' },
    // { code: 'pt', name: 'Portuguese', flag: '/images/portugual.jpg' },
    // { code: 'pl', name: 'Polish', flag: '/images/Poland.jpg' },
    { code: 'sk', name: 'Slovenčina', flag: '/images/slovakia.jpg' },
    { code: 'it', name: 'Italian', flag: '/images/italy.png' },
    // { code: 'fr', name: 'Français', flag: '/images/French.jpg' },
  ];

  var profileLink = '/profile';
  if (customerId != undefined) profileLink = `/customers/${customerId}/account/profile`;

  // Handle Logout function
  const handleLogout = () => {
    setDoLogout(true);
  };

  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [languageCode, setLanguageCode] = useState('en');
  const [selectedLanguage, setSelectedLanguage] = useState(
    languages.find((lang) => lang.code === i18n.language) || languages[0]
  );
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsDropdownOpen(false);
      }
    };

    document.addEventListener('mousedown', handleClickOutside);
    return () => document.removeEventListener('mousedown', handleClickOutside);
  }, []);

  useEffect(() => {
    if (sessionStorage.getItem('languageCode')) {
      let langCode = sessionStorage.getItem('languageCode');
      changeLanguage(langCode);
      setLanguageCode(langCode);
      setSelectedLanguage(languages.find((lang) => lang.code === langCode));
    } else if (clientUser?.associateId) {
      changeLanguage(clientUser.languageCode);
      sessionStorage.setItem('languageCode', clientUser.languageCode);
      setLanguageCode(clientUser.languageCode);
      setSelectedLanguage(
        languages.find((lang) => lang.code === clientUser.languageCode)
      );
    }
  }, []);

  // Change Language Function
  const funcChangeLanguage = (languageCode) => {
    const selectedLang = languages.find((lang) => lang?.code === languageCode);
    i18n.changeLanguage(languageCode);
    setSelectedLanguage(selectedLang);
    setIsDropdownOpen(false);

    changeLanguage(languageCode);
    sessionStorage.setItem('languageCode', languageCode);
    setLanguageCode(languageCode);
  };

  useEffect(() => {
    if (doLogout) {
      clearCacheItems();
      sessionStorage.clear();
      clearToken();
      for (let i = 0; i < localStorage.length; i++) {
        const key = localStorage.key(i);
        if (key && key.startsWith('showWalletBalance_')) {
          localStorage.removeItem(key);
          // Decrement index since localStorage key count shrinks after removal
          i--;
        }
      }
      location.href = '/?loggedout=true';
    }
  }, [doLogout]);

  const isDarkMode = theme.palette.mode === 'dark';

  const langStyles = {
    lightMode: {
      inactive: {
        backgroundColor: '#ffffff',
        color: '#374151',
      },
      active: {
        backgroundColor: '#f0f0f0',
        color: '#000',
      },
      hover: {
        backgroundColor: '#f3f4f6',
        color: '#111827',
      },
    },

    darkMode: {
      inactive: {
        backgroundColor: '#262626',
        color: '#f3f4f6',
      },

      active: {
        backgroundColor: '#3e3e3e',
        color: '#ffffff',
      },

      hover: {
        backgroundColor: '#2d2d2d',
        color: '#ffffff',
      },
    },
  };

  const getLiStyle = (isActive, isHover) => {
    if (isHover)
      return isDarkMode ? langStyles.darkMode.hover : langStyles.lightMode.hover;
    if (isActive) {
      return isDarkMode ? langStyles.darkMode.active : langStyles.lightMode.active;
    }
    return isDarkMode ? langStyles.darkMode.inactive : langStyles.lightMode.inactive;
  };

  const compileLiStyle = (str) => `${str} !important`;

  return (
    <>
      <div id='lang-menu' ref={dropdownRef}>
        <Tooltip title={t('languages')} placement='top'>
          <Link to='#' onClick={() => setIsDropdownOpen(!isDropdownOpen)}>
            <span className='lg-icon' />
          </Link>
        </Tooltip>

        <Box
          component='ul'
          className='sub-menu lang-ui'
          sx={{
            transition: 'all 0.2s ease-in-out',
            borderRadius: `0.5em !important`,
            overflow: 'hidden !important',
            backgroundColor: compileLiStyle(isDarkMode ? '#262626' : '#fff'),
            position: 'absolute',
            zIndex: 1,
            right: 0,
            left: '-50px',
            paddingLeft: '0 !important',
            paddingRight: '0 !important',
            boxShadow: [
              '0 2.8px 2.2px rgba(0, 0, 0, 0.034)',
              '0 6.7px 5.3px rgba(0, 0, 0, 0.048)',
              '0 12.5px 10px rgba(0, 0, 0, 0.06)',
              '0 22.3px 17.9px rgba(0, 0, 0, 0.072)',
              '0 41.8px 33.4px rgba(0, 0, 0, 0.086)',
              '0 100px 80px rgba(0, 0, 0, 0.12) !important',
            ].join(', '),
            border: `1px solid ${isDarkMode ? '#262626' : '#ccc'}`,
            opacity: isDropdownOpen ? 1 : 0,
            pointerEvents: isDropdownOpen ? 'auto' : 'none',
            margin: '0px',
          }}
        >
          {languages.map((lang) => (
            <Box component='li' key={lang?.code} sx={{ listStyle: 'none' }}>
              <div
                style={{
                  textDecoration: 'none',
                  padding: '0.5em 0.5em',
                  width: '100%',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                  transition: 'all 0.3s ease',
                  cursor: 'pointer',
                  backgroundColor: getLiStyle(lang?.code === selectedLanguage?.code)
                    .backgroundColor,
                  color: getLiStyle(lang?.code === selectedLanguage?.code).color,
                  borderBottom:
                    isDropdownOpen && `1px solid ${isDarkMode ? '#3c3c3c' : '#ccc'}`,
                }}
                onClick={() => funcChangeLanguage(lang?.code)}
              >
                {/*Languages flags show only on production and hide from stage*/}
                <AllowByFlag flagKey='ENHANCE_LANGUAGE_FLAG'>
                  <>
                    <img
                      src={lang.flag}
                      alt={`${lang.name} flag`}
                      style={{ width: '22px', borderRadius: '50%', height: '22px' }}
                    />
                    &nbsp;
                  </>
                </AllowByFlag>
                {lang.name}
              </div>
            </Box>
          ))}
        </Box>
      </div>

      <a
        href='#'
        className='nav-link d-flex lh-1 text-reset p-0 dropdown-toggle '
        data-bs-toggle='dropdown'
        aria-label='Open user menu'
      >
        <Avatar name={`${user?.firstName} ${user?.lastName}`} size='sm' />
      </a>
      <div
        className={`p-0 dropdown-menu dropdown-menu-end dropdown-menu-arrow mui-mode-${theme.palette.mode}`}
      >
        <Link
          to={profileLink}
          className='dropdown-item'
          style={{ padding: '14px 12px' }}
          title='Manage'
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='icon dropdown-item-icon'
            width='40'
            height='40'
            viewBox='0 0 24 24'
            strokeWidth='1'
            stroke='currentColor'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
            <path d='M12 13a3 3 0 1 0 0 -6a3 3 0 0 0 0 6z'></path>
            <path d='M6.201 18.744a4 4 0 0 1 3.799 -2.744h4a4 4 0 0 1 3.798 2.741'></path>
            <path d='M19.875 6.27c.7 .398 1.13 1.143 1.125 1.948v7.284c0 .809 -.443 1.555 -1.158 1.948l-6.75 4.27a2.269 2.269 0 0 1 -2.184 0l-6.75 -4.27a2.225 2.225 0 0 1 -1.158 -1.948v-7.285c0 -.809 .443 -1.554 1.158 -1.947l6.75 -3.98a2.33 2.33 0 0 1 2.25 0l6.75 3.98h-.033z'></path>
          </svg>
          {t('profile')}
        </Link>
        <div className='dropdown-divider m-0'></div>
        <button
          className='dropdown-item'
          style={{ padding: '14px 12px' }}
          onClick={handleLogout}
        >
          <svg
            xmlns='http://www.w3.org/2000/svg'
            className='icon dropdown-item-icon'
            width='24'
            height='24'
            viewBox='0 0 24 24'
            strokeWidth='2'
            stroke='currentColor'
            fill='none'
            strokeLinecap='round'
            strokeLinejoin='round'
          >
            <path stroke='none' d='M0 0h24v24H0z' fill='none'></path>
            <path d='M14 8v-2a2 2 0 0 0 -2 -2h-7a2 2 0 0 0 -2 2v12a2 2 0 0 0 2 2h7a2 2 0 0 0 2 -2v-2'></path>
            <path d='M7 12h14l-3 -3m0 6l3 -3'></path>
          </svg>
          {t('logout')}
        </button>
      </div>
    </>
  );
};

export default AccountMenu;
